import { HelpCircle } from 'lucide-react';
import React from 'react';

/**
 * Универсальная функция для получения иконки инструмента контакта
 * @param {Object} tool - Объект инструмента
 * @param {Object} options - Параметры конфигурации
 * @param {string} options.size - Размер иконки (по умолчанию 'h-4 w-4')
 * @param {string} options.defaultColor - Цвет по умолчанию (по умолчанию 'text-light-text-tertiary dark:text-dark-text-tertiary')
 * @param {string} options.fallbackColor - Цвет fallback иконки (по умолчанию 'text-light-text-secondary dark:text-dark-text-secondary')
 * @returns {React.Component} Компонент иконки
 */
export const getToolIcon = (tool, options = {}) => {
  const {
    size = 'h-4 w-4',
    defaultColor = 'text-light-text-tertiary dark:text-dark-text-tertiary',
    fallbackColor = 'text-light-text-secondary dark:text-dark-text-secondary'
  } = options;

  // Если инструмент не передан, возвращаем дефолтную иконку
  if (!tool) {
    return <HelpCircle className={`${size} ${defaultColor}`} />;
  }

  // Если у инструмента есть кастомная иконка, используем её
  if (tool.icon) {
    return (
      <div className="inline-block">
        <img
          src={tool.icon}
          alt={tool.name || 'Tool icon'}
          className={`${size} object-contain`}
          onError={(e) => {
            // Скрываем изображение и показываем fallback иконку
            e.target.style.display = 'none';
            const fallbackIcon = e.target.parentElement.querySelector('.fallback-icon');
            if (fallbackIcon) {
              fallbackIcon.style.display = 'block';
            }
          }}
        />
        <HelpCircle className={`${size} ${defaultColor} fallback-icon hidden`} />
      </div>
    );
  }

  // Fallback к дефолтной иконке, если нет кастомной
  return <HelpCircle className={`${size} ${fallbackColor}`} />;
};

/**
 * Создает React элемент для иконки инструмента
 * Обёртка для корректного рендеринга в React компонентах
 * @param {React.Component} iconComponent - Компонент иконки от getToolIcon
 * @returns {React.Element} React элемент
 */
export const createToolIconElement = (iconComponent) => {
  return React.createElement('span', {
    className: 'inline-flex items-center'
  }, iconComponent);
};

export default getToolIcon;
